import * as Constant from './constant';

export const initialState = { data: [], loading: false, error: false, drawer: false, deleteModal: false };

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constant.LIST_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        data: [],
        error: false,
      };
    case Constant.LIST_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        // totalCount: action.payload.total,
        data: action.payload.subscriptionreports,
        error: false,
      };
    case Constant.LIST_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        error: true,
      };

    case Constant.ADD_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case Constant.ADD_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case Constant.ADD_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case Constant.EDIT_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case Constant.EDIT_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case Constant.EDIT_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case Constant.DELETE_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case Constant.DELETE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case Constant.DELETE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case Constant.TOGGLE_DRAWER:
      return {
        ...state,
        drawer: !state.drawer,
      };

    case Constant.TOGGLE_DELETE_MODAL:
      return {
        ...state,
        deleteModal: !state.deleteModal,
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
